import { createFileRoute } from "@tanstack/react-router";
import { RequireAuth } from "@/components/RequireAuth";
import { PersonaShell } from "@/components/layouts/PersonaShell";

/**
 * `/app` layout — gated by authentication and persona role.
 *
 * Persona is derived from `window.location.hostname` (see resolvePersona) so
 * the URL space below stays uniform across subdomains. The shell rendered
 * inside the guard is the persona's own: AttendeeShell, PartnerShell, or
 * OrganizerShell.
 */
export const Route = createFileRoute("/app")({
  component: AppLayout,
});

function AppLayout() {
  return (
    <RequireAuth>
      <PersonaShell />
    </RequireAuth>
  );
}
